import React, { useEffect, useRef, useState } from 'react'
import { animated, config, useSpring } from 'react-spring'
import { useMeasure } from 'react-use'

interface SlideFromEdgeProps {
  pageIndex: number
  slideDirection?: 'left' | 'right' | undefined
  children?: React.ReactNode
  disableInitialAnimation?: boolean
}

export type SlideDirection = 'left' | 'right' | undefined

const SlideFromEdge: React.FC<SlideFromEdgeProps> = ({
  slideDirection = 'left',
  pageIndex,
  children,
  disableInitialAnimation = true,
}) => {
  const [trigger, setTrigger] = useState(false)
  const [ref, { width }] = useMeasure()
  const initialRender = useRef(disableInitialAnimation)

  useEffect(() => {
    if (initialRender.current) {
      initialRender.current = false
    } else {
      setTrigger((prev) => !prev)
    }
  }, [pageIndex])

  const styles = useSpring({
    from: {
      transform: slideDirection
        ? slideDirection === 'left'
          ? `translateX(-${width / 2}px)`
          : `translateX(${width / 2}px)`
        : `translateX(0px)`,
    },
    to: { transform: `translateX(0px)` },
    reset: trigger,
    config: config.stiff,
    onRest: () => setTrigger((prev) => !prev),
  })

  return (
    <animated.div style={styles}>
      <div ref={ref}>{children}</div>
    </animated.div>
  )
}

export default SlideFromEdge
